export const es = {
  "nav.check_booking": "Verificar Reserva",
  "nav.admin": "Admin",
  "nav.book_now": "Reservar Ahora",
  "nav.driver": "Conductor",
  "hero.badge": "Transporte para Estudiantes J1",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Tu Transporte de Confianza desde Chicago a Wisconsin",
  "hero.description": "Transporte seguro, confiable y asequible para estudiantes con visa J1. ¡Reserva tu recogida o regreso hoy!",
  "hero.book_trip": "Reserva Tu Viaje",
  "hero.check_status": "Verificar Estado de Reserva",
  "pricing.title": "Precios de Transporte",
  "pricing.subtitle": "Todos los precios en USD",
  "pricing.ohare_mke": "Recogida (O'Hare / Milwaukee)",
  "pricing.midway": "Recogida (Midway)",
  "pricing.madison": "Madison a Wisconsin Dells",
  "pricing.return": "Descuento por Regreso",
  "pricing.shared": "Viaje Compartido",
  "pricing.private": "Viaje Privado",
  "pricing.per_person": "por persona",
  "pricing.after_deposit": "con depósito de $20",
  "pricing.without_deposit": "sin depósito",
  "pricing.flat_rate": "tarifa fija",
  "pricing.per_suitcase": "Por maleta",
  "pricing.carry_on": "Equipaje de mano",
  "pricing.free": "GRATIS",
  "pricing.with_shipping": "Retorno + envío con nosotros",
  "pricing.special_deal": "¡Oferta Especial!",
  "pricing.midway_contact": "Contáctenos para precios de Midway (MDW)",
  "pricing.waterpark_note": "Los precios pueden variar para Three Bears Water Park u otros destinos.",
  "pricing.contact_us": "Contáctenos",
  "pricing.guidelines_title": "Cómo Funcionan Nuestros Precios",
  "pricing.guidelines_deposit": "Un depósito de $20 por persona asegura tu reserva. El saldo restante se paga el día del viaje.",
  "pricing.guidelines_shared": "2 o más pasajeros viajando el mismo día al mismo aeropuerto obtienen la tarifa de viaje compartido.",
  "pricing.guidelines_solo": "Los pasajeros solos (único pasajero ese día) pueden tener una tarifa ligeramente más alta.",
  "pricing.guidelines_suitcase": "1 maleta incluida gratis en viajes de regreso. Cada maleta adicional cuesta $5.",
  "pricing.guidelines_payment": "Aceptamos pagos con Tarjeta, Efectivo y Zelle.",
  "requirements.title": "Requisitos de Reserva",
  "requirements.pickup": "Ofrecemos recogidas dos veces en 24 horas salvo notificación previa. ¡Planifica y reserva con anticipación!",
  "requirements.deposit": "Se requiere un depósito no reembolsable de $3,200 JMD (o $20 USD) antes de agregarte al horario.",
  "requirements.seamless": "Asegura tu lugar haciendo tu depósito con anticipación para evitar retrasos.",
  "requirements.final_payment": "El saldo restante se debe pagar antes de subir al vehículo.",
  "special.title": "¿Destino no listado?",
  "special.description": "Ofrecemos viajes especiales a destinos fuera de nuestras rutas regulares. ¡Contáctenos para una cotización!",
  "special.call": "Llamar",
  "special.whatsapp": "WhatsApp",
  "features.title": "¿Por Qué Elegir Easy Transportation?",
  "features.subtitle": "Confiado por miles de estudiantes J1 cada verano",
  "features.easy_booking": "Reserva Fácil",
  "features.easy_booking_desc": "Solo se requiere depósito de $3,200 JMD ($20 USD). Paga por transferencia, tarjeta, PayPal o Zelle.",
  "features.safe": "Seguro y Confiable",
  "features.safe_desc": "Conductores profesionales, vehículos cómodos y soporte 24/7 para estudiantes J1.",
  "features.flexible": "Horario Flexible",
  "features.flexible_desc": "Reserva viajes de llegada y regreso. ¡Primera maleta gratis en regresos!",
  "video.badge": "Míranos en Acción",
  "video.title": "Tu Viaje Comienza Aquí",
  "video.subtitle": "Mira estudiantes J1 de Jamaica y República Dominicana comenzar su aventura",
  "video.book_now": "Reserva Tu Viaje Ahora",
  "booking.title": "Reserva Tu Viaje",
  "booking.step": "Paso",
  "booking.of": "de",
  "booking.trip_type": "Tipo de Viaje",
  "booking.arrival": "Llegada (Recogida en Aeropuerto)",
  "booking.return": "Regreso (Al Aeropuerto)",
  "booking.ride_type": "Tipo de Servicio",
  "booking.shared_ride": "Viaje Compartido",
  "booking.shared_desc": "Comparte con otros pasajeros en la misma ruta",
  "booking.private_ride": "Viaje Privado",
  "booking.private_desc": "Vehículo exclusivo solo para ti",
  "booking.pickup_location": "Aeropuerto de Recogida",
  "booking.select_airport": "Seleccionar Aeropuerto",
  "booking.travel_date": "Fecha de Viaje",
  "booking.travel_time": "Hora de Llegada Estimada",
  "booking.departure_time": "Hora de Salida",
  "booking.flight_number": "Número de Vuelo",
  "booking.airline": "Aerolínea",
  "booking.terminal": "Terminal de Llegada",
  "booking.full_name": "Nombre Completo",
  "booking.whatsapp": "Número de WhatsApp",
  "booking.email": "Correo Electrónico",
  "booking.housing": "Unidad de Vivienda",
  "booking.select_housing": "Seleccionar Vivienda",
  "booking.custom_address": "Ingresar Dirección Personalizada",
  "booking.num_passengers": "Número de Pasajeros",
  "booking.suitcases": "Total de Maletas",
  "booking.shipping": "¿Usa T&M Courier Services?",
  "booking.payment": "Método de Pago",
  "booking.referral": "Código de Referencia",
  "booking.next": "Siguiente",
  "booking.previous": "Anterior",
  "booking.submit": "Completar Reserva",
  "booking.processing": "Procesando...",
  "booking.start_over": "Empezar de Nuevo",
  "booking.first_time": "Primera Vez Viajando",
  "booking.returning": "Cliente que Regresa",
  "booking.confirmation_number": "Número de Confirmación",
  "pricing_summary.title": "Resumen de Precios",
  "pricing_summary.trip_price": "Precio del Viaje",
  "pricing_summary.luggage_fee": "Cargo por Equipaje",
  "pricing_summary.deposit": "Depósito",
  "pricing_summary.per_person": "por persona",
  "pricing_summary.discount": "Descuento por Referencia",
  "pricing_summary.total_now": "Total a Pagar Ahora",
  "pricing_summary.balance": "Saldo Restante",
  "success.title": "¡Reserva Confirmada!",
  "success.confirmation": "Número de Confirmación",
  "success.details": "Detalles de la Reserva",
  "success.whatsapp_optin": "Recibir actualizaciones por WhatsApp",
  "success.home": "Volver al Inicio",
  "driver.title": "Panel del Conductor",
  "driver.login": "Acceso de Conductor",
  "driver.phone": "Número de Teléfono",
  "driver.pin": "Código PIN",
  "driver.sign_in": "Iniciar Sesión",
  "driver.trips_today": "Viajes de Hoy",
  "driver.upcoming": "Próximos Viajes",
  "driver.passengers": "pasajeros",
  "driver.suitcases": "maletas",
  "driver.navigate": "Navegar a Recogida",
  "driver.contact": "Contactar Pasajero",
  "driver.complete": "Completar Viaje",
  "driver.logout": "Cerrar Sesión",
  "driver.no_trips": "No hay viajes programados",
  "common.loading": "Cargando...",
  "common.error": "Algo salió mal",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.details": "Detalles",
  "common.status": "Estado",
  "common.date": "Fecha",
  "common.time": "Hora",
  "common.price": "Precio",
  "common.passenger": "Pasajero",
  "common.passengers": "Pasajeros",
};
